import { QueryCache, QueryClient } from 'react-query'

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnMount: false,
      refetchOnReconnect: false,
      refetchOnWindowFocus: false,
      cacheTime: 0,
      staleTime: 0,
      suspense: false,
      retry: false,
    },
  },
  queryCache: new QueryCache({
    onError: async () => {
      // message.error('something went wrong!')
    },
  }),
})
